import { Component } from "react";

// Catches render/lifecycle errors anywhere below it so a single failure
// degrades to a readable message instead of a fully blank page.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface the real error in the console for diagnosis.
    console.error("App error boundary caught:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <section className="section">
          <div className="container cart-empty">
            <div className="cart-empty__icon">⚠️</div>
            <h2>Something went wrong</h2>
            <p>We hit an unexpected error loading this page. Please refresh, or head back home.</p>
            <div className="hero__actions" style={{ justifyContent: "center" }}>
              <a href="/" className="btn btn--primary btn--lg">Back to home</a>
              <button className="btn btn--ghost btn--lg" onClick={() => window.location.reload()}>
                Refresh
              </button>
            </div>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
